const configure = {
  // https://edemoapi.zithas.com/api/retrieveAccessToken // api to retrieve access token for onedrive

  // apiUrl: "https://mars.ztpl.net/api",
  // imgUrl: "https://mars.ztpl.net/application/public",
  // appUrl: "/",

  // appUrl: "/",
  // apiUrl: "https://api.zithas.com/api",
  // imgUrl: "https://api.zithas.com/application/public",   // Live
  // nodeApi: 'https://napi.zithas.com/api',
  // nodeImgApi: 'https://napi.zithas.com',
  // exchangeKey: "HBhbjhBY9Zui0q8XUT0O7BcuFgs9l5q5",
  // domain: "hr.zithas.in",
  type: 2, // Earth

  // demo 
  appUrl: "/human-resource/",
  apiUrl: "https://edemoapi.zithas.com/api",
  imgUrl: "https://edemoapi.zithas.com/application/public",
  nodeApi: "https://endemoapi.zithas.com/api",
  nodeImgApi: "https://endemoapi.zithas.com",
  exchangeKey: "M5CQtQbJko1A2CDN4tjHvF9qFTkgQIoG", 
 

  proxy: "https://cors-anywhere.herokuapp.com/",
  websiteUrl: "https://ztpl.net/mars-react",

  dashboardModule: 3
  // earth - 1 (default)
  // finance - 2
  // hr - 3
  // crm - 4
  // crm - 5
}

export default configure